import { useQuery } from "@tanstack/react-query";

export function useStocks() {
  return useQuery({
    queryKey: ["stocks"],

    queryFn: async () => {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycby0pOyh0k7TLN4JRUeavJ3PqDacT_2xcWoQfbJQCDVmAk-wbpafllUldB6VVF_VOM1k/exec",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const json = await response.json();

      // Your Apps Script returns: { success: true, data: [...] }
      return json.data ?? [];
    },

    staleTime: 60_000,
    refetchInterval: 30_000,
  });
}